<div class="segmented-control" #segmentedControl>
    <div
        class="sliding-background"
        [class.first-position]="slidingBackgroundPositionClass === 'first'"
        [class.middle-position]="slidingBackgroundPositionClass === 'middle'"
        [class.last-position]="slidingBackgroundPositionClass === 'last'"
        [class.single-position]="slidingBackgroundPositionClass === 'single'"
        [style.transform]="'translateX(' + slidingBackgroundPosition + 'px)'"
        [style.width]="slidingBackgroundWidth + 'px'"
    ></div>
    <button
        type="button"
        class="segment"
        *ngFor="let label of labels; trackBy: trackByLabel; let i = index"
        [class.selected]="isSelected(label)"
        (click)="onSegmentClick(label, i)"
        [attr.aria-pressed]="isSelected(label)"
        [attr.data-test]="getTestAttribute(label)"
        #segmentButton
    >
        {{ label }}
    </button>
</div>
